import * as React from "react";
import VerbConstants from "motw_core/Constants/VerbConstants";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { FilterByEmotionOptions } from "source/app/presentation/MainPanel/Dreams/Filter/Emotion/FilterByEmotionOptions";

export function FilterByEmotion({
    style,
    onChange,
    selectedAttribute,
}: FilterByEmotionOptions) {
    return (
        <div id="emotionSelector">
            <FormSelect
                id="emotion"
                label="Emotion"
                width="100%"
                classes={style}
                suggestions={VerbConstants.Verbs.All().map((elem) => elem.symbol)}
                onChange={onChange}
                value={selectedAttribute} />
        </div>
    );
}
